
import React, { cloneElement, forwardRef, Ref } from "react";
import { Swiper, SwiperSlide, SwiperProps } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode"
import "swiper/css/pagination"
import styles from "./styles.scss";

import SwiperCore, {
	Autoplay, Pagination, EffectCoverflow
} from 'swiper';

type AcProps = SwiperProps & {
	children: React.ReactNode[];
	className: string;
}

SwiperCore.use([Autoplay, EffectCoverflow, Pagination]);


function AcSwipe<T extends AcProps, P = Ref<{}>>(props: T, ref: P): JSX.Element {
	const { children, allowTouchMove = true, ...rest } = props;
	const childrenArray = React.Children.toArray(children);

	const swiperChildren = childrenArray.map((child: any, index: number) => {
		return (
			<SwiperSlide key={index} >
				{cloneElement(child, {
					key: index,
					className: `${child?.props?.className
						} ${styles['swiper-slide']} `,
				})
				}
			</SwiperSlide>);
	});



	return (
		<>
			{swiperChildren.length > 0 ? <Swiper {...rest} allowTouchMove={allowTouchMove} >
				{swiperChildren}
			</Swiper> : null}
		</>
	)

}
export default forwardRef(AcSwipe)
